import { render, staticRenderFns } from "./fileComponent.vue?vue&type=template&id=1a63d9a8"
import script from "./fileComponent.vue?vue&type=script&lang=js"
export * from "./fileComponent.vue?vue&type=script&lang=js"
import style0 from "./fileComponent.vue?vue&type=style&index=0&id=1a63d9a8&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a63d9a8')) {
      api.createRecord('1a63d9a8', component.options)
    } else {
      api.reload('1a63d9a8', component.options)
    }
    module.hot.accept("./fileComponent.vue?vue&type=template&id=1a63d9a8", function () {
      api.rerender('1a63d9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploadFiles/fileComponent.vue"
export default component.exports